import { render, staticRenderFns } from "./RightStat.vue?vue&type=template&id=96cb0b12&scoped=true&"
import script from "./RightStat.vue?vue&type=script&lang=js&"
export * from "./RightStat.vue?vue&type=script&lang=js&"
import style0 from "./RightStat.vue?vue&type=style&index=0&id=96cb0b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cb0b12",
  null
  
)

export default component.exports